export default __webpack_public_path__ + "images/9daa33179a82001ad7c92d050445f476-video.svg";